import {isEnglish} from "./language";

const APP_CLASS_PREFIX = 'elfsight-app-';

/**
 * Elfsight initialisiert seine Widgets über die Klasse elfsight-app-<appID>.
 * Auf der englischen Seite wird diese Klasse durch die aus data-elfsight-id-en
 * ersetzt – die enthält den vollständigen Klassennamen inkl. Prefix.
 */
function swapElfsightAppIds() {
    if (!isEnglish()) return;

    for (const el of document.querySelectorAll('[data-elfsight-id-en]')) {
        const englishClass = el.dataset.elfsightIdEn;
        if (!englishClass) continue;

        const currentClass = [...el.classList].find(cls => cls.startsWith(APP_CLASS_PREFIX));
        if (!currentClass || currentClass === englishClass) continue;

        el.classList.replace(currentClass, englishClass);
    }
}

/**
 * Muss laufen, bevor platform.js die Widgets initialisiert – deshalb so früh
 * wie möglich und nicht erst im window-load-Handler.
 */
export function initElfsightLanguage() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', swapElfsightAppIds, {once: true});
        return;
    }

    swapElfsightAppIds();
}
